import React from "react";
import { Spinner } from "@fluentui/react-components";
import PropTypes from "prop-types";

export default function FluentSpinner({
  appearance = "inverted",
  size = "extra-tiny",
  label,
}) {
  return <Spinner appearance={appearance} label={label} size={size} />;
}

FluentSpinner.propTypes = {
  appearance: PropTypes.string,
  size: PropTypes.string,
  label: PropTypes.string,
};
